// extracted by mini-css-extract-plugin
export default {"root":"_32IeD","text-block":"_2UGvU","textBlock":"_2UGvU","prefix":"_1gmDT"};